// @flow
import axios from 'lib/defaultClient';

export type WriteCommentPayload = {
  quoteId: string,
  text: string,
  replyTo?: ?string,
};

export const writeComment = ({ quoteId, text, replyTo }: WriteCommentPayload) =>
  axios.post(`/quotes/${quoteId}/comments`, {
    text,
    reply_to: replyTo,
  });

export type ReadCommentsPayload = {
  quoteId: string,
};

export const readComments = ({ quoteId }: ReadCommentsPayload) =>
  axios.get(`/quotes/${quoteId}/comments`);

export type ReadSubCommentsPayload = {
  quoteId: string,
  commentId: string,
  parentId?: ?string,
};

export const readSubComments = ({ quoteId, commentId }: ReadSubCommentsPayload) =>
  axios.get(`/quotes/${quoteId}/comments/${commentId}/replies`);

export type RemoveCommentPayload = {
  quoteId: string,
  commentId: string,
};

export const removeComment = ({ quoteId, commentId }: RemoveCommentPayload) => {
  return axios.delete(`/quotes/${quoteId}/comments/${commentId}`);
};

export type EditCommentPayload = {
  quoteId: string,
  commentId: string,
  text: string,
  parentId: ?string,
};

export const editComment = ({ quoteId, commentId, text }: EditCommentPayload) =>
  axios.patch(`/quotes/${quoteId}/comments/${commentId}`, { text });



// WEBPACK FOOTER //
// ./src/lib/api/quotes/comments.js